// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectId } from './FoodProject';
import { foodSensoryQuestionType } from './FoodSensoryQuestionType';
import { foodSensoryTestType } from './FoodSensoryTestType';
import { z } from 'zod';
export const foodSensoryQuestionId = (z.number());
export const foodSensoryQuestion = z.object({
    id: foodSensoryQuestionId,
    project_id: foodProjectId,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    test_type: foodSensoryTestType,
    options: z.unknown().nullable(),
    min_value: z.number(),
    max_value: z.number(),
    min_label: z.string().nullable(),
    max_label: z.string().nullable(),
    display_order: z.number(),
    required: z.boolean(),
    created_at: z.date().nullable(),
    is_headline: z.boolean(),
});
export const foodSensoryQuestionInitializer = z.object({
    id: foodSensoryQuestionId.optional(),
    project_id: foodProjectId,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    test_type: foodSensoryTestType.optional(),
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    created_at: z.date().optional().nullable(),
    is_headline: z.boolean().optional(),
});
export const foodSensoryQuestionMutator = z.object({
    id: foodSensoryQuestionId.optional(),
    project_id: foodProjectId.optional(),
    text: z.string().optional(),
    question_type: foodSensoryQuestionType.optional(),
    test_type: foodSensoryTestType.optional(),
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    created_at: z.date().optional().nullable(),
    is_headline: z.boolean().optional(),
});
//# sourceMappingURL=FoodSensoryQuestion.js.map